/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Delete_Document_DeletingInputs */

const en_orders_delete_document_deleting = /** @type {(inputs: Orders_Delete_Document_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const es_orders_delete_document_deleting = /** @type {(inputs: Orders_Delete_Document_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Orders_Delete_Document_DeletingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_delete_document_deleting = /** @type {((inputs?: Orders_Delete_Document_DeletingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Delete_Document_DeletingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_delete_document_deleting(inputs)
	return es_orders_delete_document_deleting(inputs)
});